export default __webpack_public_path__ + "static/media/kalpurush.d4696e55.ttf";